/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  RecordHomepageVisitMutationRequest,
  RecordHomepageVisitMutationResponse,
  RecordHomepageVisit400,
} from '../types/RecordHomepageVisit'

function getRecordHomepageVisitUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/homepage/recents/visit/` as const,
  }
  return res
}

/**
 * @summary Record a visit for the recents list
 * {@link /api/v1/homepage/recents/visit/}
 */
export async function recordHomepageVisit(
  data: RecordHomepageVisitMutationRequest,
  config: Partial<RequestConfig<RecordHomepageVisitMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    RecordHomepageVisitMutationResponse,
    ResponseErrorConfig<RecordHomepageVisit400>,
    RecordHomepageVisitMutationRequest
  >({
    method: 'POST',
    url: getRecordHomepageVisitUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
